"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

const DEFAULT_POLL_INTERVAL_MS = 120_000

function getPollIntervalMs() {
  const configured = Number(process.env.NEXT_PUBLIC_POLL_INTERVAL_MS)
  return Number.isFinite(configured) && configured > 0
    ? configured
    : DEFAULT_POLL_INTERVAL_MS
}

export function ContentPoller({ enabled }: { enabled: boolean }) {
  const router = useRouter()

  useEffect(() => {
    if (!enabled) {
      return
    }

    const pollIntervalMs = getPollIntervalMs()

    const refreshIfVisible = () => {
      if (document.hidden) {
        return
      }

      router.refresh()
    }

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshIfVisible()
      }
    }

    const intervalId = setInterval(refreshIfVisible, pollIntervalMs)
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      clearInterval(intervalId)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [enabled, router])

  return null
}
